/**
 * The owner's own photographs of his own plants.
 *
 * These nine are fixed seed assets, not uploads, so they ship with the app
 * rather than living in object storage. Photographs added later — from the
 * Telegram bot, as a plant changes — are a different problem and belong in R2.
 *
 * Keyed on the accepted scientific name, which is stable; common names are not.
 *
 * They are served from /photos/ and NOT from /plants/, which is a route. A
 * static directory that shares a name with a route shadows it: nginx resolves
 * the directory first, redirects to add the trailing slash, finds no index
 * inside and answers 403 — so the collection page 403'd on a hard load while
 * working perfectly when reached by a link. Keep this path out of the router's
 * namespace.
 */
const BY_SPECIES: Record<string, string> = {
  "Salvia rosmarinus": "rosemary.jpg",
  "Thymus spp.": "thyme.jpg",
  "Ocimum basilicum": "basil.jpg",
  "Mesembryanthemum cordifolium": "aptenia.jpg",
  "Dracaena trifasciata": "sansevieria.jpg",
  "Philodendron 'Birkin'": "philodendron-birkin.jpg",
  "Stromanthe sanguinea 'Triostar'": "stromanthe-triostar.jpg",
  "Chlorophytum comosum": "spider-plant.jpg",
  "Codiaeum variegatum": "croton.jpg",
};

export function photoFor(scientificName: string | undefined): string | null {
  if (!scientificName) return null;
  const file = BY_SPECIES[scientificName];
  return file ? `/photos/${file}` : null;
}

/**
 * The two fertiliser labels.
 *
 * He reads the dose off the bottle, so wherever the app names a dose it shows
 * the bottle beside it. Matched on the product's own name rather than its id,
 * because the id is a seed detail and the name is what the guide calls it.
 */
export function productPhotoFor(productName: string | undefined): string | null {
  if (!productName) return null;
  const name = productName.toUpperCase();
  if (name.includes("AGRI")) return "/photos/product-agri19-label.jpg";
  if (name.includes("CITO")) return "/photos/product-c-cito-label.jpg";
  return null;
}
